//
// User Selector
//
// ---------------------------------------------------------------------------

'use strict';

import 'select2';

const config = {
    select2Target: '.c-select-user',
    emailTarget: '.js-email-field',
    emailToggleTarget: '.js-email-toggle',
    select2ContainerTarget: '.select2-container',
    hiddenClass: 'hidden',
    placeholderText: 'Search for a user...'
};

class UserSelection {

    constructor() {
        if(!$(config.select2Target).length) {
            return;
        }

        this.bindElements();
        this.setupSelect();
        this.setupEmailToggle();
        this.setFieldVisibility(this.$emailField.val() !== '');
    }

    /**
     * Bind common elements
     */
    bindElements() {
        this.$select2Field = $(config.select2Target);
        this.$emailToggle = $(config.emailToggleTarget);
        this.$emailField = $(config.emailTarget);
        this.searchUrl = this.$select2Field.data('searchUrl');
    }

    /**
     * Initialise the select2 form fields.
     */
    setupSelect() {
        if (this.$select2Field.find("option[value='placeholder']").length) {
            this.$select2Field.val('placeholder').trigger('change');
        } else {
            let defaultOption= new Option(config.placeholderText, 'placeholder', true, true);
            this.$select2Field.append(defaultOption).trigger('change');
        }
        this.$select2Field.select2({
            ajax: {
                placeholder: config.placeholderText,
                initSelection: function() {
                    this.$select2Field.val('placeholder').trigger('change');
                },
                url: this.searchUrl,
                dataType: 'json',
                processResults: function (data) {
                    // Transforms the top-level key of the response object from 'items' to 'results'
                    return {
                        results: data
                    };
                },
                data: function (params) {
                    return {
                        search: params.term
                    };
                },
                allowClear: true,
                minimumInputLength: 2
            }
        })
    }

    setupEmailToggle() {
        const $emailContainer = this.$emailField.parent();

        $emailContainer.addClass(config.hiddenClass);

        this.$emailToggle.change((event) => {
            this.setFieldVisibility(event.target.checked);
        });
    }

    setFieldVisibility(useEmailAddress) {
        const $emailContainer = this.$emailField.parent();
        const $select2Container = $(config.select2ContainerTarget).parent();

        if (useEmailAddress) {
            $emailContainer.removeClass(config.hiddenClass);
            $select2Container.addClass(config.hiddenClass);
            this.$select2Field.val('').trigger('change');
        } else if (!useEmailAddress) {
            $emailContainer.addClass(config.hiddenClass);
            this.$emailField.val('');
            $select2Container.removeClass(config.hiddenClass);
            this.$select2Field.val('placeholder').trigger('change');
        }
    }
}

$(window).load(function(){
    new UserSelection();
});



// WEBPACK FOOTER //
// ./src/js/components/user-select.js